<template>
  <div id="app">
    <router-view />

    <!-- <p v-if="testVersion" class="version">version: {{ testVersion }}</p> -->
  </div>
</template>
<script>
import packageJson from "../package.json";

export default {
  name: "app",
  computed: {
    testVersion() {
      const network = process.env.NODE_ENV;
      if (network === "mainnet") return null;

      return packageJson.version;
    },
  },
  mounted() {
    document.getElementById("loadingWrap").style.display = "none";
  },
};
</script>
<style lang="scss" scoped>
.version {
  position: fixed;
  bottom: 0;
  right: 0;
  background-color: rgb(23 23 23 / 36%);
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 10px 0 0 0;
}
</style>
